module.exports = __webpack_public_path__ + "static/media/set_Fairies.df8a74e8.jpg";